import React from 'react'
import { t } from 'ttag'
import styles from './AssessmentSummary.module.scss'

export const AssessmentSummary = ({ jobSeeker }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{t`Assessment Summary`}</div>
      <div className={styles.paragraph}>
        {t`The following results are based on the Personality Test and Interest Test completed by ${jobSeeker.name}.`}
      </div>
      <br />
      <div className={styles.paragraph}>
        <b>{t`Interest match`}</b>{' '}
        {t`is measured on a scale from 0 to 100 and reflects how strongly a person is drawn to a given talent area.`}
      </div>
      <br />
      <div className={styles.paragraph}>
        <b>{t`Personality match`}</b>{' '}
        {t`is measured on a scale from 0 to 100 and indicates how naturally predisposed the person is to excel in that area, based on their personality profile.`}
      </div>
      <br />
      <div className={styles.paragraph}>
        {t`All talent areas are grouped into eight categories, which can be found in the last column of the table below.`}
      </div>
      <br />

      <div className={styles.note}>
        <b>{t`Note`}:</b>{' '}
        {t`These results provide guidance and insight rather thandefinitive judgments. They should be used to inspire development and understanding of natural strengths and interests.`}
      </div>
    </div>
  )
}
